import { render } from "./ModalDeliveryChargeTiers.vue?vue&type=template&id=db2e003a&scoped=true"
import script from "./ModalDeliveryChargeTiers.vue?vue&type=script&lang=js"
export * from "./ModalDeliveryChargeTiers.vue?vue&type=script&lang=js"

import "./ModalDeliveryChargeTiers.vue?vue&type=style&index=0&id=db2e003a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2e003a"]])

export default __exports__